// import React, { useEffect, useState } from "react";
// import { Card, Form, Row, Col, Button, Container } from "react-bootstrap";
// import {
//   IconStar,
//   IconStarFilled,
//   IconThumbUp,
//   IconThumbDown,
// } from "@tabler/icons-react";
// import logo from "../../assets/logo.svg";
// import "./FeedbackForm.css";
// import { useParams } from "react-router-dom";
// import usePostRequest from "../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../constant/_constant";

// const options = [
//   { label: "Fast And Timely Service", value: "option1" },
//   { label: "Easy And Smooth Process", value: "option2" },
//   { label: "Good Value For Money", value: "option3" },
//   { label: "High Product/Service Quality", value: "option4" },
//   { label: "Excellent Support After Purchase", value: "option5" },
// ];

// function FeedbackForm() {
//   const { token } = useParams();

//   const [selected, setSelected] = useState(null);

//   const handleSelect = (value) => {
//     setSelected(value);
//   };

//   const [orderRating, setOrderRating] = useState(null);
//   const [productRating, setProductRating] = useState(0);
//   const [logisticsRating, setLogisticsRating] = useState(0);
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [recommend, setRecommend] = useState(null);
//   const [tokenError, setTokenError] = useState(null);

//   const handleCheckboxChange = (event) => {
//     const { value, checked } = event.target;
//     if (checked) {
//       setSelectedOptions([...selectedOptions, value]);
//     } else {
//       setSelectedOptions(selectedOptions.filter((v) => v !== value));
//     }
//   };

//   const { postData: verifyToken, isLoading: verifying } = usePostRequest(
//     API_ENDPOINTS.VERIFY_FEEDBACK_TOKEN
//   );

//   useEffect(() => {
//     if (token) {
//       verifyToken(
//         { token: token },
//         (response) => {
//           console.log("Token verified:", response);
//           setTokenError(null);
//         },
//         (error) => {
//           console.error("Token verification failed:", error);
//           setTokenError(error?.message || "Token verification failed.");
//         }
//       );
//     }
//   }, [token]);

//   return (
//     <Container>
//       <Row className="justify-content-md-center">
//         <Col md={8}>
//           <Card className="feedback_from">
//             <Card.Header className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h2>Customer Feedback Form</h2>
//                 <Card.Text>
//                   Kindly provide your feedback to help us enhance our services.
//                 </Card.Text>
//               </div>
//               <div>
//                 <img src={logo} alt="logo" />
//               </div>
//             </Card.Header>
//             <Card.Body>
//               <Form>
//                 <Form.Group className="mb-4">
//                   <Form.Label>How would you rate our order?</Form.Label>
//                   <div className="order-rating-container">
//                     <div className="numbers">
//                       {Array.from({ length: 11 }, (_, i) => (
//                         <button
//                           key={i}
//                           type="button"
//                           className={`number-box ${
//                             selected !== null && i <= selected ? "active" : ""
//                           }`}
//                           onClick={() => handleSelect(i)}
//                         >
//                           {i}
//                         </button>
//                       ))}
//                     </div>
//                     <div className="bar">
//                       <div className="labels">
//                         <span>Poor</span>
//                         <span>Excellent</span>
//                       </div>
//                     </div>
//                   </div>
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>
//                     How would you rate quality of products?
//                   </Form.Label>
//                   <div className="stars">
//                     {Array.from({ length: 5 }, (_, i) => (
//                       <button
//                         key={i}
//                         type="button"
//                         className="star-button"
//                         onClick={() => setProductRating(i + 1)}
//                       >
//                         {i < productRating ? (
//                           <IconStarFilled
//                             size={32}
//                             stroke={1.5}
//                             color="#FFA500"
//                           />
//                         ) : (
//                           <IconStar size={32} stroke={1.5} color="#999" />
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>How would you rate our logistics?</Form.Label>
//                   <div className="stars">
//                     {Array.from({ length: 5 }, (_, i) => (
//                       <button
//                         key={i}
//                         type="button"
//                         className="star-button"
//                         onClick={() => setLogisticsRating(i + 1)}
//                       >
//                         {i < logisticsRating ? (
//                           <IconStarFilled
//                             size={32}
//                             stroke={1.5}
//                             color="#FFA500"
//                           />
//                         ) : (
//                           <IconStar size={32} stroke={1.5} color="#999" />
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>What did you like about our service?</Form.Label>
//                   {options.map((opt) => (
//                     <Form.Check
//                       key={opt.value}
//                       type="checkbox"
//                       id={opt.value}
//                       label={opt.label}
//                       value={opt.value}
//                       checked={selectedOptions.includes(opt.value)}
//                       onChange={handleCheckboxChange}
//                     />
//                   ))}
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>
//                     Would you recommend our company to others?
//                   </Form.Label>
//                   <div className="recommend-buttons">
//                     <button
//                       type="button"
//                       className={`recommend-button ${
//                         recommend === "yes" ? "active" : ""
//                       }`}
//                       onClick={() => setRecommend("yes")}
//                     >
//                       <IconThumbUp
//                         size={20}
//                         color={recommend === "yes" ? "#FF6600" : "#999"}
//                       />
//                       <span>Yes</span>
//                     </button>
//                     <button
//                       type="button"
//                       className={`recommend-button ${
//                         recommend === "no" ? "active" : ""
//                       }`}
//                       onClick={() => setRecommend("no")}
//                     >
//                       <IconThumbDown
//                         size={20}
//                         color={recommend === "no" ? "#FF6600" : "#999"}
//                       />
//                       <span>No</span>
//                     </button>
//                   </div>
//                 </Form.Group>

//                 <Form.Group className="mb-4">
//                   <Form.Label>
//                     Do you have any additional feedback or suggestions for us?
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     placeholder="Type your feedback here..."
//                     style={{ height: "100px" }}
//                   />
//                 </Form.Group>

//                 <Button variant="primary" className="submit-button">
//                   Submit Feedback
//                 </Button>
//               </Form>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// export default FeedbackForm;

import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Container,
  Spinner,
} from "react-bootstrap";
import {
  IconStar,
  IconStarFilled,
  IconThumbUp,
  IconThumbDown,
  IconThumbUpFilled,
  IconThumbDownFilled,
} from "@tabler/icons-react";
import logo from "../../assets/logo.svg";
import { useParams } from "react-router-dom";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import "./FeedbackForm.css";
import InvalidLink from "./InvalidLink";
import SuccessModal from "./SuccessModal";
import auth_background from "../../assets/auth_background.webp";
import useIdleLogout from "../../hooks/useIdleLogout";

const options = [
  { label: "Fast And Timely Service", value: "liked_fast_service" },
  { label: "Easy And Smooth Process", value: "liked_easy_process" },
  { label: "Good Value For Money", value: "liked_good_value" },
  { label: "High Product/Service Quality", value: "liked_high_quality" },
  { label: "Excellent Support After Purchase", value: "liked_support_after" },
];

function FeedbackForm() {
  const { token } = useParams();

  const [orderRating, setOrderRating] = useState(null); // 0-10
  const [productRating, setProductRating] = useState(0); // 1-5
  const [logisticsRating, setLogisticsRating] = useState(0); // 1-5
  const [selectedOptions, setSelectedOptions] = useState([]); // array of liked options
  const [recommend, setRecommend] = useState(null); // 'yes' | 'no'
  const [additionalFeedback, setAdditionalFeedback] = useState("");
  const [tokenError, setTokenError] = useState(null);
  const [errorText, setErrorText] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { postData: verifyToken, data: tokenData } = usePostRequest(
    API_ENDPOINTS.VERIFY_FEEDBACK_TOKEN
  );
  const { postData: submitFeedback, isLoading } = usePostRequest(
    API_ENDPOINTS.SUBMIT_FEEDBACK
  );

  useEffect(() => {
    if (token) {
      verifyToken(
        { token },
        (response) => {
          console.log("Token Verified:", response);
          setErrorText(null);
        },
        (error) => {
          console.error("Token verification failed:", error);
          setTokenError(error?.message || "Token verification failed.");
          if (error?.status === "A") {
            setErrorText(errorMessages.submittedError);
          } else if (error?.status === "I") {
            setErrorText(errorMessages.invalidTokenError);
          } else {
            setErrorText(error?.message || "Token verification failed.");
          }
        }
      );
    }
  }, [token]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedOptions((prev) =>
      checked ? [...prev, value] : prev.filter((v) => v !== value)
    );
  };

  useIdleLogout();

  const errorMessages = {
    submittedError: (
      <>
        Thank You! You've already submitted your feedback — we really appreciate
        it! Your input helps us improve and continue providing great service. If
        you have anything more you'd like to share, feel free to reach out to us
        at {""}
        <a href="mailto:platform_admin@aspettoinc.com">
          platform_admin@aspettoinc.com
        </a>
      </>
    ),

    invalidTokenError: (
      <>
        Oops! It seems that the token is invalid or expired. Please check the
        link or contact support if you believe this is an error. You can reach
        us at {""}
        <a href="mailto:platform_admin@aspettoinc.com">
          platform_admin@aspettoinc.com
        </a>{" "}
        for assistance.
      </>
    ),
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      orderRating === null ||
      productRating === 0 ||
      logisticsRating === 0 ||
      recommend === null
    ) {
      toast.error("Please complete all required fields.");
      return;
    }

    const feedbackPayload = {
      token,
      order_rating: orderRating,
      product_quality_rating: productRating,
      logistics_rating: logisticsRating,
      liked_fast_service: selectedOptions.includes("liked_fast_service"),
      liked_easy_process: selectedOptions.includes("liked_easy_process"),
      liked_good_value: selectedOptions.includes("liked_good_value"),
      liked_high_quality: selectedOptions.includes("liked_high_quality"),
      liked_support_after: selectedOptions.includes("liked_support_after"),
      would_recommend: recommend === "yes",
      additional_feedback: additionalFeedback,
    };

    submitFeedback(
      feedbackPayload,
      (res) => {
        toast.success("Feedback submitted successfully!");
        setShowSuccessModal(true);
        // Reset form
        setOrderRating(null);
        setProductRating(0);
        setLogisticsRating(0);
        setSelectedOptions([]);
        setRecommend(null);
        setAdditionalFeedback("");
      },
      (err) => {
        toast.error(err?.message || "Something went wrong.");
      }
    );
  };

  if (tokenError) {
    return (
      <InvalidLink
        isOpen={true}
        errorMessage={tokenError}
        mainText={errorText}
        redirectPath="/"
      />
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${auth_background})`,
      }}
      className="full_modal_bg"
    >
      <Container>
        <Row className="justify-content-md-center align-items-center">
          <Col md={9}>
            <Card className="feedback_from mt-4">
              <Card.Header className="d-flex align-items-center justify-content-between p-4">
                <div>
                  <h2> Customer Feedback Form</h2>
                  <Card.Text>
                    Kindly provide your feedback to help us enhance our
                    services.
                  </Card.Text>
                </div>
                <img src={logo} alt="logo" />
              </Card.Header>
              <Card.Body className="p-4">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b> How would you rate our order?</b>
                    </Form.Label>
                    <div className="order-rating-container">
                      <div className="numbers">
                        {Array.from({ length: 11 }, (_, i) => (
                          <button
                            key={i}
                            type="button"
                            className={`number-box ${
                              orderRating !== null && i <= orderRating
                                ? "active"
                                : ""
                            }`}
                            onClick={() => setOrderRating(i)}
                          >
                            {i}
                          </button>
                        ))}
                      </div>
                      <div className="bar">
                        <div className="labels">
                          <span>Poor</span>
                          <span>Excellent</span>
                        </div>
                      </div>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b>How would you rate quality of products?</b>
                    </Form.Label>
                    <div className="stars">
                      {Array.from({ length: 5 }, (_, i) => (
                        <button
                          key={i}
                          type="button"
                          className="star-button"
                          onClick={() => setProductRating(i + 1)}
                        >
                          {i < productRating ? (
                            <IconStarFilled
                              size={32}
                              stroke={1.5}
                              color="#FFA500"
                            />
                          ) : (
                            <IconStar size={32} stroke={1.5} color="#999" />
                          )}
                        </button>
                      ))}
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b>How would you rate our logistics?</b>{" "}
                    </Form.Label>
                    <div className="stars">
                      {Array.from({ length: 5 }, (_, i) => (
                        <button
                          key={i}
                          type="button"
                          className="star-button"
                          onClick={() => setLogisticsRating(i + 1)}
                        >
                          {i < logisticsRating ? (
                            <IconStarFilled
                              size={32}
                              stroke={1.5}
                              color="#FFA500"
                            />
                          ) : (
                            <IconStar size={32} stroke={1.5} color="#999" />
                          )}
                        </button>
                      ))}
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b>What did you like about our service?</b>{" "}
                    </Form.Label>
                    {options.map((opt) => (
                      <Form.Check
                        className="mb-2"
                        key={opt.value}
                        type="checkbox"
                        id={opt.value}
                        label={opt.label}
                        value={opt.value}
                        checked={selectedOptions.includes(opt.value)}
                        onChange={handleCheckboxChange}
                      />
                    ))}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b>Would you recommend our company to others?</b>
                    </Form.Label>
                    <div className="recommend-buttons">
                      <button
                        type="button"
                        className={`recommend-button ${
                          recommend === "yes" ? "active" : ""
                        }`}
                        onClick={() => setRecommend("yes")}
                      >
                        <IconThumbUpFilled
                          size={20}
                          color={recommend === "yes" ? "#FF6600" : "#999"}
                        />
                        <span>Yes</span>
                      </button>
                      <button
                        type="button"
                        className={`recommend-button ${
                          recommend === "no" ? "active" : ""
                        }`}
                        onClick={() => setRecommend("no")}
                      >
                        <IconThumbDownFilled
                          size={20}
                          color={recommend === "no" ? "#FF6600" : "#999"}
                        />
                        <span>No</span>
                      </button>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <b>
                        Do you have any additional feedback or suggestions for
                        us?
                      </b>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Type your feedback here..."
                      style={{ height: "100px" }}
                      value={additionalFeedback}
                      onChange={(e) => setAdditionalFeedback(e.target.value)}
                    />
                  </Form.Group>

                  <div className="text-center">
                    <Button
                      variant="warning"
                      type="submit"
                      className="submit-button w-auto"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Submit Feedback"
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {showSuccessModal && <SuccessModal isOpen={showSuccessModal} />}
      </Container>
    </div>
  );
}

export default FeedbackForm;
